import * as NavConstants from 'constants/NavConstants';
import {AgentType, ChatType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ChatDraftStatus, createChatWithDraftMessage} from 'llm/chat-library/ChatActions';
import {openExistingChat} from 'llm/chat-library/sidepanel/AISidepanelV2GlobalClientState';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';

/**
 * Creates a new chat in ASK mode with the given prompt and opens the AI sidepanel.
 *
 * Passes draft directly to createChatWithDraftMessage to avoid clobbering any user-authored draft.
 *
 * @param prompt - The prompt text to send
 * @param fileId - The ID of the file to explore
 * @returns Promise that resolves to the created chat session ID
 */
export async function openExploreChat(prompt: string, fileId: string): Promise<string> {
  const {chatSessionId} = await createChatWithDraftMessage(ChatType.DEEP_RESEARCH, {
    createParams: {contextIds: [fileId]},
    draft: {
      status: ChatDraftStatus.DRAFT,
      message: {text: prompt, selectedFiles: []},
      settings: {agentType: AgentType.ASK, publicDataEnabled: false},
    },
  });

  // Open the chat in the AI sidepanel without fully expanding it
  openExistingChat(chatSessionId);
  SidepanelActions.openSection(NavConstants.SECTIONS.AI);

  return chatSessionId;
}
